import {db} from "@/main";
import Api from "@/helpers/api.js";

export default {
	namespaced: true,
	state: {
		configList: [],
		followerConfig: {
			config: null,
			exist: false,
		},
	},
	actions: {
		fetchCompanyConfigList({commit}) {
			return new Promise((resolve, reject) => {
				Api.get("/config/company")
					.then((res) => {
						commit("setConfigs", res.data);
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		async fetchCompanyConfigFollower({commit}) {
			const response = await Api.get("/config_company_info/followers");
			if (response.status === 200) {
				commit("setFollowerConfigAvailable", response.data);
			}
			return response;
		},
		getRef({commit}, data) {
			return db.ref(data);
		},
		update({commit}, data) {
			return db.ref().update(data);
		},
		updateData({commit}, el, data) {
			return db.ref(el).update(data);
		},
		detachEvent(state, data) {
			db.ref(data).off();
		},
		updateLocalCompanyConfigList({commit}, config) {
			commit("updateConfig", config);
		},
	},
	mutations: {
		setConfigs(state, configs) {
			state.configList = configs;
		},
		updateConfig(state, newConfig) {
			const configIndex = state.configList.findIndex(
				(config) => config.type_config_id === newConfig.type_config_id
			);
			if (configIndex >= 0) {
				state.configList[configIndex].config_json = newConfig.config_json;
			}
		},
		setFollowerConfigAvailable(state, data) {
			state.followerConfig.config = data.config;
			state.followerConfig.exist = data.exist;
		},
	},
	getters: {
		serviformConfig(state) {
			return state.configList.find((config) => config.type_config_name === "SERVIFORMS");
		},
		servirouteConfig(state) {
			return state.configList.find((config) => config.type_config_name === "SERVIROUTES");
		},
		visualConfig(state) {
			return state.configList.find((config) => config.type_config_name === "VISUAL_CONFIG");
		},
		visitpointConfig(state) {
			return state.configList.find((config) => config.type_config_name === "VISIT_POINT");
		},
		modulesConfig(state) {
			return state.configList.find((config) => config.type_config_name === "MODULS");
		},
		onDemandConfig(state) {
			return state.configList.find((config) => config.type_config_name === "ON_DEMAND");
		},
		getConfigByType: (state) => (type) => {
			return state.configList.find((config) => config.type_config_name === type);
		},
		getFollowersConfig(state) {
			return state.followerConfig;
		},
	},
};
